module.exports = __webpack_public_path__ + "static/cloud-storage-copy-e2b7e0c8fec04965133ceb5cecf48488.png";